import { instance } from "api/apiBase";

export interface AddressValidationIssue {
  id?: string;
  property_id: string;
  property_name: string;
  unit_id: string | null;
  unit_number: string | null;
  address: string;
  issue: string;
  first_flagged_at: string;
}

interface AddressValidationIssuesPage {
  items: AddressValidationIssue[];
  current_page: number;
  page_count: number;
  total_count: number;
  has_more: boolean;
}

const ADDRESS_VALIDATION_ISSUES_URL = "/portal/v1/address_validation_issues";

export const addressValidationIssuesApi = {
  getIssues: async ({
    page = 1,
    per_page = 10
  }: {
    page?: number;
    per_page?: number;
  } = {}): Promise<AddressValidationIssuesPage> =>
    (
      await instance.get<AddressValidationIssuesPage>(
        ADDRESS_VALIDATION_ISSUES_URL,
        {
          params: { page, per_page }
        }
      )
    ).data
};
